export const ERROR_ACTIONS = {
  HANDLE_ERROR: 'ERROR_ACTIONS/HANDLE_ERROR',
}
